export enum BlackHorseCompanies {
    BlackHorse = 'Black Horse',
    JaguarFinancialServices = 'Jaguar Financial Services',
    LandroverFinancialServices = 'Landrover Financial Services',
    SuzukiFinancialServices = 'Suzuki Financial Services',
    Shogun = 'Shogun'
  }
